import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { RootModule } from './app/root.module';
import { environment } from '@environment';

if (environment.production) {
  enableProdMode();
}

// if (!(window !== window.parent && !window.opener)) {
//   platformBrowserDynamic()
//     .bootstrapModule(RootModule)
//     .catch(err => console.log(err));
// } else {
//   platformBrowserDynamic()
//     .bootstrapModule(HandlerMsalModule)
//     .catch(err => console.log(err));
// }

// platformBrowserDynamic()
//   .bootstrapModule(RootModule)
//   .catch(err => console.error(err));

platformBrowserDynamic()
  .bootstrapModule(RootModule)
  .then(_ => {
    // import('bluebird').then(Bluebird => {
    //   const Zone = (window as any)['Zone'];
    //   Zone[Zone['__symbol__']('bluebird')](Bluebird.default);
    // });
  })
  .catch(err => console.error(err));
